export default "__VITE_ASSET__DZGmkggf__"